import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { QA_NAME_MODAL_OPEN_IN_NEW_WINDOW_BTN } from '../../../constants/qa'
import { useLinkLikeClick } from '../../../hooks'
import Button from '../../Button'

import OpenInNewWindowIcon from '../../../icons/open-in-new-window.svg'

function ModalOpenInNewWindowButton({ link, ...restProps }) {
  const { t } = useTranslation()

  const { handleClick: handleLinkClick, handleMouseDown: handleLinkMouseDown } =
    useLinkLikeClick()

  function handleClick(event) {
    handleLinkClick({ event, link, target: HTML_LINK_TARGET.blank })
  }

  function handleMouseDown(event) {
    handleLinkMouseDown({ event, link })
  }

  return (
    <Button.Text
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: OpenInNewWindowIcon }}
      qaName={QA_NAME_MODAL_OPEN_IN_NEW_WINDOW_BTN}
      tooltip={t('Common.LinkTooltipOpenInNewTabKey')}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
    />
  )
}

export default ModalOpenInNewWindowButton
